import { Experiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

interface Options {
  canActivate?: boolean
}

function useCroRoomAmenitiesInsteadOfDescription(options?: Options) {
  return useExperiment(Experiments.croRoomAmenitiesInsteadOfDescription, {
    canActivate: options?.canActivate ?? false,
  })
}

export default useCroRoomAmenitiesInsteadOfDescription
